import { useEffect } from 'react';
import { getStickerPacks } from '@livelike/javascript';
import { stickerPackStoreActions } from '../store/stickerPack';

export function useLoadStickerPacksEffect() {
  useEffect(() => {
    const getPacks = async () => {
      const response = await getStickerPacks();
      if (response.results.length > 0) {
        stickerPackStoreActions.updateStickerPacksAction(response.results);
      }
    };
    getPacks();
  }, []);
}
